module.exports = __webpack_public_path__ + "media/images/landing/persons/petr-sadilek-79724d96ca00bd101bed8f43e65e4328.jpg";